@if (profileState.deposits() === null || profileState.deposits()!.length > 0) {
  @if (!isLg()) {
    <div class="w-full">
      <div class="w-full overflow-hidden px-[3.2rem] pb-[3.2rem]">
        @if (!isLoading()) {
          <div class="table__head mb-[1rem] px-[1.6rem] text-[1.2rem] font-350 leading-[1.6rem] text-light-200">
            <span>ID</span>
            <span i18n="@@profile.method">Способ</span>
            <span i18n="@@profile.type">Тип</span>
            <span></span>
            <span i18n="@@profile.date">Дата</span>
            <span class="text-right" i18n="@@profile.status">Статус</span>
          </div>

          <div class="table__wrapper flex flex-col space-y-[0.2rem]">
            @for (deposit of profileState.deposits(); track deposit.id) {
              <div class="table__row h-[6rem] shrink-0 rounded-[1.2rem] bg-[#202956] px-[1rem] overflow-hidden">
                <ng-container [ngTemplateOutlet]="id" [ngTemplateOutletContext]="{ id: deposit.id }" />

                @if (deposit?.method?.icon; as icon) {
                  <ng-container
                    [ngTemplateOutlet]="methodIcon"
                    [ngTemplateOutletContext]="{
                    fileName: icon?.fileName ?? '',
                    icon: icon
                  }"
                  />
                }
                @if (deposit.method) {
                  <ng-container
                    [ngTemplateOutlet]="methodName"
                    [ngTemplateOutletContext]="{
                    animatedIconName: deposit?.method?.animatedIconName,
                    isGiftCode: deposit?.method?.isGiftCode,
                    name: deposit?.method?.name
                  }"
                  />
                }

                <ng-container
                  [ngTemplateOutlet]="amount"
                  [ngTemplateOutletContext]="{ amountUsd: deposit.amountUsd }"
                />
                <ng-container [ngTemplateOutlet]="date" [ngTemplateOutletContext]="{ createdAt: deposit.createdAt }" />
                <ng-container [ngTemplateOutlet]="status" [ngTemplateOutletContext]="{ status: deposit.status }" />
              </div>
            }
          </div>
        } @else {
          <div class="table__wrapper">
            @for (row of preloadRows; track $index) {
              <preload-rect className="row__preload preload" [background]="'#202956'" />
            }
          </div>
        }
      </div>
    </div>
  } @else {
    @if (!isLoading()) {
      <div
        class="mob-table-wrapper flex max-h-[69.8rem] w-full flex-col space-y-[0.2rem] overflow-auto px-[1.6rem] pb-[1.6rem]"
      >
        @for (deposit of profileState.deposits(); track deposit.id) {
          <div class="flex h-[9.8rem] w-full shrink-0 flex-col justify-between rounded-[1.2rem] bg-[#202956] p-[1rem]">
            <div class="flex w-full flex-1 items-start justify-between">
              <div class="flex items-center space-x-[1rem]">
                @if (deposit?.method?.icon; as icon) {
                  <ng-container
                    [ngTemplateOutlet]="methodIcon"
                    [ngTemplateOutletContext]="{
                      fileName: icon?.fileName ?? '',
                      icon: icon
                    }"
                  />
                }
                @if (deposit.method) {
                  <ng-container
                    [ngTemplateOutlet]="methodName"
                    [ngTemplateOutletContext]="{
                    animatedIconName: deposit?.method?.animatedIconName,
                    isGiftCode: deposit?.method?.isGiftCode,
                    name: deposit?.method?.name
                  }"
                  />
                }
              </div>

              <div class="flex flex-col pr-[0.2rem] pt-[0.1rem] lg:items-end">
                <ng-container
                  [ngTemplateOutlet]="amount"
                  [ngTemplateOutletContext]="{ amountUsd: deposit.amountUsd }"
                />
                <ng-container [ngTemplateOutlet]="date" [ngTemplateOutletContext]="{ createdAt: deposit.createdAt }" />
              </div>
            </div>
            <div
              class="flex h-[4.2rem] w-full shrink-0 items-center justify-between rounded-[0.8rem] bg-[#293366] px-[0.8rem]"
            >
              <ng-container [ngTemplateOutlet]="id" [ngTemplateOutletContext]="{ id: deposit.id }" />
              <ng-container [ngTemplateOutlet]="status" [ngTemplateOutletContext]="{ status: deposit.status }" />
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="table__wrapper flex w-full shrink-0 flex-col space-y-[0.2rem] px-[1.6rem] pb-[1.6rem]">
        @for (row of preloadRows; track $index) {
          <preload-rect
            className="w-full h-[6rem] !rounded-[1.2rem] lg:h-[9.8rem] shrink-0 preload"
            [background]="'#202956'"
          />
        }
      </div>
    }
  }
} @else {
  <div class="no-deposit">
    <div class="no-deposit__info icon icon_info-instruction"></div>

    <div class="no-deposit__title" i18n="@@profile.deposit.no_deposit.title">У вас нет депозитов!</div>
    <div class="no-deposit__sub-title" i18n="@@profile.deposit.no_deposit.sub_title">
      Пополняйте свой баланс и удваивайте его в играх!
    </div>

    <a class="btn no-deposit__button" routerLink="/payment">
      <i class="icon icon_wallet-bold"></i>
      <ng-container i18n="@@profile.deposit.no_deposit.button">Пополнить баланс</ng-container>
    </a>
  </div>
}

<ng-template #date let-createdAt="createdAt">
  <date-utc
    class="text-[1.3rem] font-325 leading-[1.6rem] text-[#9CB3ED] lg:text-[1rem] lg:leading-[1.2rem]"
    [timestamp]="createdAt"
    format="HH:mm DD.MM.YY"
  />
</ng-template>

<ng-template #amount let-amountUsd="amountUsd">
  @if (amountUsd) {
    <currency-input
      iconClass="text-[1.3rem] lg:text-[1rem] !text-[#FFC583]"
      valueClass="text-[1.3rem] text-[#FFC583] font-400 lg:text-[1rem] lg:leading-[1.4rem] lg:font-350"
      [value]="amountUsd"
    />
  } @else {
    <span></span>
  }
</ng-template>

<ng-template #methodIcon let-fileName="fileName" let-icon="icon">
  @if (icon) {
    <img
      loading="lazy"
      class="object-contain max-h-[2.4rem] max-w-[10rem]"
      alt="Method icon"
      fetchpriority="low"
      [src]="fileName | paymentMethodImage"
    />
  } @else {
    <span>-</span>
  }
</ng-template>

<ng-template #methodName let-animatedIconName="animatedIconName" let-isGiftCode="isGiftCode" let-name="name">
  <span class="text-[1.3rem] font-350 leading-[1.6rem] text-[#CDDBFF] lg:text-[1.2rem] lg:leading-[1.4rem]">
    @if (animatedIconName) {
      <animated-card class="method__anime" [animatedIconName]="animatedIconName" />
    }
    {{ isGiftCode ? 'GIFTCODE' : name }}
  </span>
</ng-template>

<ng-template #id let-id="id">
  <div
    class="flex h-[4rem] w-min items-center justify-center space-x-[0.2rem] rounded-[1rem] bg-[#293366] px-[1.8rem] text-[1.2rem] font-400 leading-[1.6rem] lg:h-[2.8rem] lg:w-min lg:rounded-[0.6rem] lg:bg-[#32417B] lg:px-[1.2rem] lg:text-[1.1rem] lg:leading-[1.4rem]"
  >
    <span class="text-[#6175A5]">ID</span>
    <span class="text-[#E1EAFF]">{{ id }}</span>
  </div>
</ng-template>

<ng-template #status let-status="status">
  <div class="flex items-center justify-end space-x-[0.4rem]">
    <span
      class="text-[1.2rem] font-400"
      [ngClass]="{
        'text-[#FFCF91]': status === 1,
        'text-[#6DEA5D]': status === 2,
        'text-[#F85769]': status === 3 || status === 4 || status === 5
      }"
    >
      @switch (status) {
        @case (1) {
          Processing
        }
        @case (2) {
          Done
        }
        @case (3) {
          Error
        }
        @case (4) {
          Refunded
        }
        @case (5) {
          Declined
        }
      }
    </span>
    <img
      class="h-[2.8rem] w-[2.8rem] lg:h-[2.4rem] lg:w-[2.4rem]"
      [src]="
        (status === 1 && '/assets/images/history/proccessing.webp') ||
        (status === 2 && '/assets/images/history/done.webp') ||
        (status === 3 && '/assets/images/history/error.webp') ||
        (status === 4 && '/assets/images/history/error.webp') ||
        (status === 5 && '/assets/images/history/declined.webp')
      "
      alt=""
    />
  </div>
</ng-template>
